<template>
    <button class="operations-pending-button" @click="navigateByName(routeList.APPROVALS_PENDING_SIGNATURE_NAME)">
        <icon-pencil-line class="pencil"/>
        <div class="text-counter-wrapper">
            {{t('home.signOperations')}}
            <!-- Loader Generic -->
            <loaders-generic v-if="showOperationsPendingLoader" isSmall/>
            <!-- Counter -->
            <div v-if="!showOperationsPendingLoader && getSignListCounter" class="counter">{{getSignListCounter}}</div>
        </div>
        <Icon-arrow-right-full/>
    </button>
</template>

<script setup>
import LoadersGeneric from '@/components/generic/loaders/Generic'
import IconPencilLine from '@/assets/icons/pencil-line.svg?inline'
import IconArrowRightFull from '@/assets/icons/arrow-right-full.svg?inline'
/* Vue & Helpers */
import { ref } from 'vue'
import { navigateByName } from '@/router/helpers/navigation'
import { routeList } from '@/router/helpers/routes'
/* Store */
import { mapActions, mapGetters } from '@/store/helpers/mappers'
import { moduleMapper } from '@/store/helpers/modules.map'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/* mapActions & mapGetters */
const { requestedSignListCounter } = mapActions(moduleMapper.HOME)
const { getSignListCounter } = mapGetters(moduleMapper.HOME)
const { getAppThemeMode } = mapGetters()

const showOperationsPendingLoader = ref(false)
const fetchToSignList = async () => {
    showOperationsPendingLoader.value = true

    try {
        await requestedSignListCounter({ status: 'NotSignedByMe' })
        showOperationsPendingLoader.value = false
    } catch {
        /* Do nothing */
        showOperationsPendingLoader.value = false
    }
}

fetchToSignList()
</script>

<style lang="scss" scoped>
.operations-pending-button {
    width: 242px;
    height: 56px;
    padding: 0 20px 0 16px;

    display: flex;
    align-items: center;

    @include H7-Medium;
    color: var(--dashboard-01-button-text);

    border-radius: 8px;
    background-color: var(--dashboard-01);
    box-shadow: var(--box-shadow-3);
    cursor: pointer;

    .text-counter-wrapper {
        width: 100%;
        display: flex;
        align-items: center;

        .counter {
            width: 22px;
            height: 22px;
            margin: 0 6px;

            flex-shrink: 0;

            @include H8-Medium;
            line-height: 22px;

            background-color: var(--dashboard-04);
            border-radius: 50%;
        }

        :deep(.spinner-wrapper) {
            margin: 0 6px;
        }
    }

    svg {
        flex-shrink: 0;

        &.pencil {
            margin-right: 8px;
        }

        :deep(.change-color-fill) {
            fill: var(--dashboard-01-button-text);
        }
    }

    @media (hover: hover) and (pointer: fine) {
        &:hover {
            background-color: var(--dashboard-01-state-hover);
        }
    }

    &:focus {
        background-color: var(--dashboard-01-state-press);
    }
}
</style>
